var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomLeather(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.8 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.8,91h-6.8c-.16,0-.32-.08-.41-.22-2.42-3.52-5.22-6.16-8.33-7.84-4.48-2.38-9.96-2.95-15.03-1.56l-1.77,.59c-.22,.07-.45-.01-.58-.2-1.45-2.21-2.93-4.41-4.41-6.62-1.47-2.19-2.94-4.39-4.39-6.58-.09-.13-.11-.29-.06-.44,.05-.15,.17-.26,.31-.31,1.63-.54,3.03-1.26,4.15-2.12,3.32-2.47,5.93-6.15,7.33-10.36,1.51-4.35,1.94-9.46,1.28-15.18-.91-7.26-4.12-13.97-9.06-18.9-1.34-1.34-2.58-2.32-3.79-3.02-.12-.07-.21-.19-.24-.32-.03-.14,0-.28,.07-.39C2.93,13.3,5.88,8.93,8.89,4.61c.15-.22,.45-.28,.67-.14,2.04,1.26,4.23,2.56,6.6,3.35,2.61,.95,4.77,1.17,6.62,.69,1.5-.35,2.92-1.41,3.91-2.89,0,0,0,0,0,0,.93-1.35,1.49-3.04,1.72-5.17,.03-.25,.24-.45,.5-.45h18.8c.26,0,.48,.2,.5,.46,.2,2.39,1.09,4.54,2.58,6.21,1.09,1.19,2.58,1.95,4.18,2.14,2.09,.17,4.4-.31,7.04-1.46,1.68-.75,3.23-1.6,5.03-2.76,.23-.15,.53-.09,.68,.14,1.45,2.09,2.92,4.16,4.39,6.23,1.48,2.08,2.96,4.16,4.41,6.27,.08,.11,.11,.25,.08,.39-.03,.13-.11,.25-.23,.32-1.58,.97-3.11,2.31-4.68,4.1-2.91,3.21-5.16,6.99-6.5,10.93-1.68,4.68-2.3,10.07-1.78,15.59,.53,5.12,2.19,9.63,4.8,13.04,1.71,2.17,4.53,5.02,8.26,6.23,.15,.05,.27,.16,.32,.31,.05,.15,.03,.31-.05,.44-1.44,2.18-2.9,4.37-4.37,6.55-1.49,2.22-2.97,4.43-4.43,6.65-.14,.21-.4,.28-.62,.18-1.98-.9-4.26-1.36-6.79-1.36-3.98-.11-7.97,1.01-11.23,3.12-2.71,1.77-5.08,4.15-7.06,7.06-.09,.14-.25,.22-.41,.22Zm-6.54-1h6.27c2.02-2.92,4.44-5.32,7.19-7.12,3.43-2.22,7.59-3.38,11.79-3.28,2.5,0,4.79,.43,6.8,1.27,1.39-2.1,2.8-4.2,4.21-6.31,1.34-2,2.69-4.01,4.01-6.01-3.66-1.38-6.42-4.18-8.12-6.35-2.72-3.57-4.45-8.25-5-13.56-.54-5.68,.1-11.21,1.83-16.02,1.39-4.06,3.71-7.96,6.7-11.27,1.49-1.7,2.95-3.02,4.46-4.01-1.36-1.96-2.73-3.89-4.11-5.83-1.38-1.94-2.76-3.88-4.12-5.85-1.67,1.06-3.16,1.86-4.76,2.58-2.81,1.22-5.27,1.72-7.54,1.54-1.86-.22-3.56-1.09-4.83-2.46-1.54-1.73-2.5-3.92-2.78-6.34H29.34c-.27,2.09-.87,3.79-1.83,5.18-1.13,1.69-2.77,2.9-4.5,3.31-2.04,.53-4.39,.3-7.19-.72-2.3-.77-4.41-1.98-6.39-3.2C6.63,9.61,3.88,13.69,1.21,17.64c1.15,.72,2.31,1.67,3.54,2.9,5.09,5.09,8.41,12.01,9.34,19.49,.68,5.88,.23,11.14-1.32,15.63-1.47,4.4-4.19,8.25-7.67,10.84-1.06,.82-2.35,1.51-3.83,2.06,1.33,2.01,2.68,4.03,4.03,6.04,1.41,2.1,2.82,4.2,4.21,6.3l1.44-.48c5.34-1.47,11.09-.87,15.79,1.63,3.18,1.73,6.05,4.4,8.53,7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.4,3.7c.7-.4,1.6,.2,1.7,.9,0,.4-.4,.8-.8,.8-.5,.1-1-.1-1.3-.6-.1-.3,0-.9,.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.3,4.6c.6-.3,1.4,.4,1.1,1-.3,.6-1.2,.6-1.5,0-.2-.4,0-.9,.4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.7,7c.6-.2,1.3,.2,1.6,.7s0,1.1-.5,1.3c-.6,.3-1.5-.1-1.7-.7-.3-.5,.1-1.1,.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.2,7.4c.6-.3,1.5,.1,1.6,.8,.1,.8-1.2,1.3-1.7,.7-.5-.4-.6-1.3,.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.9,8.4c.5-.2,1.2,.2,1.3,.7,.1,.7-.8,1.1-1.3,.8-.6-.3-.6-1.3,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.9,9.1c.8-.5,1.8,.4,1.5,1.3-.2,.5-.8,.6-1.3,.5-.7-.3-.8-1.4-.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.1,10c.7-.2,1.4,.2,1.7,.8,.1,.4,0,1-.5,1.2-.7,.3-1.6-.1-1.8-.8-.1-.5,.2-1.1,.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.8,10.3c.4-.2,1,0,1.3,.3,.3,.4,.4,1.1,0,1.4-.3,.2-.8,.3-1.2,.3-.6-.5-.9-1.6-.1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.8,11c.8-.1,1.9,.7,1.5,1.6-.4,.7-1.5,.7-2,.1-.5-.5-.2-1.5,.5-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,11.5c.7-.3,1.7,.5,1.3,1.3-.3,.6-1.2,.8-1.7,.3-.4-.5-.2-1.4,.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.9,11.6c.5-.2,1.3,0,1.5,.6,.2,.5-.1,1.1-.7,1.3-.6,.2-1.3-.2-1.4-.8-.1-.5,.2-1,.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.7,12.6c1-.4,2,.7,1.7,1.7-.2,.6-1,.9-1.6,.6-.4-.2-.8-.6-.9-1.1,0-.5,.3-1,.8-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.1,12.7c.6-.2,1.3,.1,1.5,.7,.1,.4-.3,.8-.6,.9-.7,.1-1.3-.5-1.2-1.2-.1-.1,.1-.3,.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.3,13.1c.4-.2,.9-.2,1.3,0,.6,.4,.8,1.3,.4,1.9-.7,.7-2,.2-2.1-.7-.3-.4,0-.9,.4-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.5,14.3c.6-.2,1.3,.3,1.6,.8,.2,.5-.1,1-.6,1.1-.6,.2-1.3-.2-1.5-.8-.2-.4,0-.9,.5-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.3,14.5c.7-.3,1.6,.6,1.3,1.3-.3,.6-1.2,.5-1.5,0-.4-.4-.2-1,.2-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.4,14.5c.4-.1,.8-.1,1.2,.1,.4,.2,.6,.8,.3,1.2-.3,.6-1.2,.7-1.6,.1-.4-.4-.5-1.2,.1-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.6,16.1c.8-.3,1.8,.6,1.4,1.4-.4,.7-1.5,.3-1.8-.3-.2-.5,0-1,.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.3,16c.7-.1,1.5,.5,1.4,1.3-.2,.8-1.4,1-1.9,.3-.5-.5-.1-1.4,.5-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.5,16.5c.5-.2,1.1,0,1.4,.3,.7,.7-.1,2.2-1.1,1.9-.4-.1-.8-.5-.9-.9-.1-.5,.1-1.1,.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.1,16.7c.7-.3,1.5,.3,1.6,1-.1,.8-1.2,1.1-1.8,.6-.6-.4-.5-1.4,.2-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.4,16.9c.7-.4,1.6,.2,1.7,1-.1,.4-.3,.7-.6,.9-.6,.3-1.5-.1-1.6-.8-.1-.4,.1-.9,.5-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.1,17.1c.7-.3,1.4,.2,1.5,.9,.1,.5-.4,1-.9,1-.4-.1-.7-.3-1-.6-.2-.4-.1-1.1,.4-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.4,17.2c.8-.5,1.9,.5,1.5,1.3-.4,.6-1.3,.4-1.7-.1-.3-.3-.3-1,.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.5,17.5c.4-.2,.9,0,1.2,.2,.6,.4,.5,1.6-.3,1.8-.6,.3-1.2-.2-1.5-.7-.3-.4,.1-1,.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.9,17.6c.6-.3,1.3,.4,1,1s-1.2,.6-1.5,0c-.2-.3,.1-.9,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.3,18.1c.7-.3,1.5,.2,1.6,.9,.1,.5-.4,.9-.9,1-.3,0-.7-.2-.9-.5-.4-.3-.3-1.1,.2-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.9,18.2c.6-.2,1.1,.4,1.3,.9,0,.7-.9,1.1-1.4,.7-.5-.4-.6-1.4,.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.4,19c.5-.2,1.1,.1,1.4,.5,.5,.6-.1,1.5-.7,1.5-.7,0-1.2-.7-1.2-1.3-.1-.3,.2-.6,.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.6,19.9c.7-.3,1.7,.2,1.6,1,0,.7-.8,1.2-1.4,.8-.5-.4-.9-1.5-.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.3,20c.8-.2,2,.7,1.6,1.6-.3,.8-1.6,.8-2.1,.1-.5-.5-.2-1.5,.5-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.8,20.4c.7-.3,1.6,.2,1.6,1s-1.3,1.2-1.7,.5c-.6-.4-.6-1.3,.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.6,20.9c.8-.4,1.6,.7,1.3,1.4-.3,.5-1.1,.5-1.5,0-.5-.4-.4-1.2,.2-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.4,21c.5-.3,1.3-.1,1.6,.5,.2,.7-.7,1.3-1.3,.9-.5-.2-.8-1-.3-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.4,21.4c.5-.3,1.2,.1,1.3,.7,.1,.7-.8,1.2-1.3,.8-.5-.3-.5-1.1,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.4,21.8c1-.4,2.2,.6,1.8,1.6-.5,1-2.2,.6-2.4-.4-.1-.4,0-1.1,.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.4,22c.4-.1,.9-.1,1.1,.2,.2,.2,.4,.5,.4,.8,0,.5-.3,1-.8,1s-1-.2-1.3-.6c-.3-.5,0-1.3,.6-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.4,23.3c.4-.1,.9,0,1.2,.2,.4,.4,.5,1.3-.1,1.5-.4,.2-1,.4-1.3,0-.4-.4-.5-1.4,.2-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.2,23.6c.7-.2,1.6,.5,1.3,1.2-.3,.6-1.2,.6-1.6,.1-.3-.5-.1-1.1,.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.7,23.9c.5-.2,1.3,.2,1.2,.8-.1,.7-1.1,.9-1.5,.4-.3-.4-.2-1.1,.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.9,24c.8-.3,2,.5,1.7,1.4-.1,.5-.7,.7-1.1,.7-.7-.1-1.2-.6-1.2-1.3,0-.3,.3-.7,.6-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.2,24.1c.9-.3,2.1,.7,1.6,1.6-.4,.7-1.4,.6-1.9,0-.4-.4-.3-1.3,.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.2,24.6c.8-.3,1.8,.3,1.8,1.2,0,.7-.7,1.2-1.4,1.1-.6-.1-1.1-.6-1.1-1.2,0-.4,.2-.9,.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,24.6c.6-.3,1.5,.1,1.6,.8,.1,.8-.9,1.4-1.6,1-.7-.3-.7-1.5,0-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.6,25.8c.6-.3,1.4,.1,1.6,.7,.1,.6-.7,1.2-1.2,.8-.6-.2-1-1.1-.4-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.9,26.1c.5-.2,1.3-.1,1.6,.4,.3,.5,.3,1.2-.1,1.6-.7,.6-1.9,.1-2.1-.7-.2-.4,.1-1,.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.5,26.1c.8-.4,1.9,.6,1.4,1.4-.5,.7-1.6,.2-1.8-.5-.2-.3,0-.7,.4-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.9,27.5c.7-.3,1.5,.6,1.3,1.2-.2,.6-1.1,.6-1.5,.2-.5-.3-.3-1.1,.2-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.1,28.6c.6-.2,1.5-.2,1.7,.5,.3,.8-.7,1.5-1.4,1-.5-.2-.9-1.2-.3-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.7,29.1c.7-.3,1.8,.5,1.5,1.3-.2,.7-1.2,.9-1.7,.4-.2-.2-.5-.5-.4-.9,.1-.3,.3-.6,.6-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,29.6c.7-.4,1.8,.1,1.8,.9-.1,.5-.4,1.1-1,1.2-.5,.1-1-.3-1.3-.7s0-1.1,.5-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,29.9c.7-.3,1.6,.2,1.7,1-.1,.5-.5,1.1-1,1-.6,0-1.2-.4-1.2-1-.1-.4,.1-.8,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.1,30.1c.8-.2,1.7,.6,1.3,1.4-.5,.8-1.8,.2-1.9-.6,0-.3,.3-.7,.6-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.8,30.7c.7-.4,1.6,.2,1.7,1-.1,.8-1.3,1.1-1.8,.6-.5-.4-.4-1.3,.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.9,31.1c.7-.3,1.5,.2,1.5,.9,.1,.5-.4,1-.9,1-.3-.1-.7-.3-.9-.5-.3-.4-.2-1.1,.3-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.7,31.6c.6-.3,1.3,.4,1,1s-1.1,.6-1.5,0c-.2-.3,.1-.8,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,32c.5-.2,1.1,.1,1.4,.5,.5,.7-.3,1.7-1.1,1.4-.5-.2-1-.8-.9-1.4,0-.2,.3-.4,.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.1,33.9c.8-.4,1.7,.6,1.4,1.3-.3,.5-1.1,.6-1.5,.1-.5-.3-.4-1.1,.1-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,34c.5-.3,1.3,0,1.6,.5,.2,.7-.7,1.2-1.3,.9-.6-.2-.8-1-.3-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.7,34.4c.6-.2,1.4,.2,1.4,.9,.1,.8-1,1.3-1.6,.8-.4-.3-.6-.8-.4-1.3,.2-.2,.4-.3,.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.9,34.9c.9-.5,2.2,.5,1.9,1.6-.3,.8-1.6,.8-2.1,.2-.6-.5-.5-1.6,.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.4,34.9c.8-.3,1.8,.6,1.4,1.4-.4,.6-1.4,.3-1.8-.3-.2-.4,0-.9,.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.3,35.4c.5-.2,1.2,.2,1.2,.8,0,.7-.8,1.1-1.4,.7-.4-.3-.4-1.2,.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.3,36.1c.8-.5,1.8,.5,1.5,1.3-.2,.5-.8,.6-1.3,.4-.7-.2-.9-1.3-.2-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.5,37c.6-.2,1.2,.1,1.5,.6,.4,.4,.2,1.2-.3,1.4-.7,.4-1.6-.1-1.8-.8-.2-.5,.1-1,.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.1,37.4c.6-.3,1.6,.1,1.6,.9,.2,.8-.8,1.2-1.4,1.1-.6-.5-.9-1.6-.2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.8,37.7c.9-.3,2.1,.6,1.7,1.6-.3,.7-1.3,.9-1.9,.4-.7-.5-.7-1.8,.2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,38.1c.9-.3,2.1,.7,1.6,1.6-.5,.8-1.9,.5-2.2-.4,0-.4,.2-1,.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.4,38.5c.7-.4,1.7,.4,1.4,1.2-.2,.7-1.2,.9-1.7,.4-.5-.3-.4-1.3,.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.2,38.8c.6-.3,1.5,.1,1.6,.8,0,.6-.8,1.1-1.3,.7-.6-.2-.9-1.2-.3-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.2,39.6c1-.3,1.9,.9,1.5,1.8-.3,.7-1.2,.8-1.8,.4-.4-.3-.7-.7-.7-1.1,.2-.4,.5-.9,1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.5,40.5c.7-.3,1.5,.7,1.2,1.4-.3,.5-1.1,.5-1.5,0-.4-.4-.2-1.1,.3-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.9,41.4c.7-.2,1.5,.5,1.6,1.2-.1,.9-1.4,1.1-1.9,.4-.5-.5-.4-1.5,.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.9,41.5c.6-.2,1.4,0,1.6,.6,.2,.8-1,1.4-1.6,.9-.6-.3-.7-1.3,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.3,43.8c.7-.5,1.7,.2,1.8,.9-.1,.8-1.2,1.1-1.8,.6-.5-.4-.5-1.2,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,44.2c.8-.3,1.8,.7,1.3,1.4-.5,.7-1.8,.2-1.9-.6,0-.4,.3-.7,.6-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.6,44.1c.6-.2,1.3,.3,1.4,1,.1,.5-.4,1-.9,1-.5-.1-1.2-.5-1.1-1.1,0-.4,.2-.8,.6-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.8,44.6c.4-.2,.8,0,1.2,.1,.7,.3,.7,1.4,.1,1.8-.3,.2-.8,.3-1.1,0-.3-.2-.7-.5-.7-.9-.1-.4,.1-.7,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.2,44.7c.6-.4,1.3,.3,1.1,.9-.2,.6-1,.7-1.4,.3-.3-.4-.1-1,.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.7,45c.7-.1,1.6,.5,1.4,1.3-.1,.4-.6,.9-1.1,.8-.6-.1-1-.7-1.1-1.3,.1-.5,.5-.7,.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.1,45.3c.6-.4,1.3,.2,1.5,.8,0,.6-.7,1-1.3,.7-.6-.2-.7-1.1-.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.2,46.8c.6-.2,1.3,.2,1.4,.8,.1,.6-.4,1.2-1,1.1-.5,0-.9-.5-1-1-.1-.3,.2-.8,.6-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.6,47.1c.8-.3,2,.6,1.6,1.5-.3,.8-1.5,.8-2,.2-.5-.5-.3-1.5,.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.1,47.5c.6-.3,1.5,.1,1.6,.8,.1,.8-1.2,1.3-1.7,.7-.4-.4-.6-1.3,.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.8,48.5c.5-.2,1.2,.1,1.3,.7,0,.7-.8,1.1-1.4,.8-.4-.4-.4-1.2,.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.6,49.1c.4-.1,.8-.2,1.2,0,.3,.2,.5,.6,.6,.9,0,.5-.4,1-.9,1s-1-.2-1.3-.7c-.2-.3,0-.9,.4-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.8,49.2c.8-.5,1.8,.4,1.6,1.2-.1,.5-.8,.7-1.3,.5-.7-.2-.9-1.3-.3-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.7,50.4c.6-.3,1.6,.1,1.6,.8,.2,.8-.8,1.2-1.4,1.1-.6-.3-.9-1.5-.2-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.6,50.6c.7-.2,1.6,.5,1.3,1.3-.3,.6-1.2,.5-1.6,0-.4-.4-.1-1.1,.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,51c.5-.3,1.4,.1,1.3,.8-.1,.7-1.1,.9-1.5,.4-.3-.4-.2-1.1,.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.7,51.1c.8-.2,1.9,.7,1.5,1.6-.3,.7-1.4,.7-1.9,.2-.5-.5-.3-1.6,.4-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,51.6c.8-.3,1.7,.5,1.4,1.3-.3,.6-1.2,.8-1.7,.3-.6-.5-.4-1.4,.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.8,51.7c.6-.3,1.5,.1,1.6,.9,.1,.8-1,1.4-1.6,.9-.7-.4-.7-1.6,0-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.8,52.7c.9-.2,1.8,.9,1.5,1.8-.2,.7-1.2,.9-1.8,.5-.4-.3-.7-.7-.7-1.1,.1-.6,.5-1.1,1-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.1,52.8c.6-.2,1.3,.2,1.4,.8,.1,.7-.7,1.2-1.3,.8-.5-.3-.8-1.4-.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.3,53.2c.6-.2,1.3-.1,1.6,.5,.2,.5,.3,1.2-.2,1.6-.7,.6-1.9,0-2-.8-.2-.5,.1-1.1,.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.5,54.4c.7-.1,1.5,.5,1.5,1.2-.1,.9-1.4,1.1-1.9,.4-.5-.5-.3-1.5,.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.2,54.6c.8-.4,1.7,.7,1.3,1.4-.5,.6-1.5,.3-1.6-.4-.1-.4,0-.8,.3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.1,56.2c.7-.3,1.7,.4,1.5,1.2-.1,.5-.6,.8-1.1,.8s-.9-.4-1.1-.9c.1-.5,.3-.9,.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.5,56.5c.8-.2,1.7,.7,1.3,1.4-.5,.7-1.6,.3-1.9-.4-.2-.4,.1-.9,.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.4,56.6c.7-.4,1.8,.1,1.8,1-.1,.5-.5,1.1-1,1.2-.5,.1-.9-.3-1.1-.7-.5-.4-.2-1.2,.3-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.4,56.9c.7-.3,1.5,.3,1.6,1.1-.1,.4-.3,.8-.7,1-.6,.2-1.4-.2-1.5-.8-.1-.6,.2-1.1,.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.4,57.2c.8-.4,1.9,.6,1.4,1.4-.5,.7-1.6,.2-1.8-.5-.1-.3,.1-.7,.4-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.4,57.7c.4-.2,.9,0,1.3,.2,.7,.4,.5,1.6-.3,1.8-.6,.2-1.1-.2-1.4-.6-.4-.5-.1-1.2,.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.4,58.1c.7-.2,1.3,.4,1.4,1,.1,.5-.4,1-.9,1-.5-.1-1.2-.5-1.1-1.1,0-.4,.2-.8,.6-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.9,58.2c.8-.3,1.8,.6,1.4,1.4-.5,.7-1.6,.3-1.9-.4-.1-.4,.1-.8,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.8,58.3c.6-.3,1.2,.3,1.4,.9,0,.6-.8,1.1-1.3,.7-.7-.3-.7-1.3-.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.4,59.1c.7-.2,1.7,.4,1.5,1.3-.2,.4-.6,.9-1.1,.8-.6-.1-1.1-.8-1.1-1.4,.1-.4,.4-.6,.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.7,59.9c.6-.2,1.4,.1,1.5,.8,.1,.6-.4,1.2-.9,1.1-.5,0-.9-.5-1.1-1-.2-.4,.1-.8,.5-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.1,60.2c.6-.3,1.4,.1,1.7,.7,.3,.5-.1,1.2-.6,1.4-.6,.2-1.4-.2-1.6-.8-.2-.6,0-1.1,.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.5,61c.8-.4,1.7,.6,1.3,1.3-.3,.5-1.1,.6-1.5,.1-.4-.3-.4-1.2,.2-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.6,61c.5-.1,1.3,.1,1.4,.7,0,.7-.9,1.1-1.4,.7-.6-.2-.7-1.2,0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.3,61.9c.9-.4,2.2,.5,1.8,1.6-.3,.9-1.6,.8-2.2,.2-.4-.5-.3-1.6,.4-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.3,62.1c.3-.1,.7-.1,1,.1s.5,.6,.6,.9c0,.5-.4,1-.9,1s-1.1-.2-1.3-.7c-.2-.4,.1-1.1,.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.7,63.1c.8-.4,1.7,.5,1.5,1.3-.2,.5-.8,.6-1.3,.5-.7-.2-.9-1.4-.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.1,63.7c.7-.3,1.7,.5,1.3,1.2-.3,.6-1.3,.5-1.6,0-.3-.4-.1-1,.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.6,64c.6-.2,1.3,.2,1.3,.8-.1,.7-1.1,.9-1.5,.4-.4-.4-.3-1.1,.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.8,64.1c.8-.4,2.1,.5,1.7,1.4-.1,.4-.6,.7-1,.6-.6,0-1.1-.5-1.2-1-.2-.4,.1-.8,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.1,64.2c.9-.4,2.1,.6,1.7,1.5-.4,.7-1.4,.6-1.9,.1-.5-.3-.4-1.3,.2-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.3,64.7c.9-.2,1.9,.7,1.6,1.6-.3,.8-1.4,.9-2,.4-.7-.5-.5-1.9,.4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.4,64.7c.6-.3,1.5,.2,1.5,.9,.1,.8-.9,1.4-1.6,.9-.7-.4-.7-1.6,.1-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.9,65.6c.7-.2,1.6,.6,1.3,1.4-.3,.7-1.3,.8-1.7,.2-.6-.6-.3-1.5,.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.5,65.9c.6-.3,1.4,.1,1.6,.7,.1,.6-.6,1.2-1.2,.9-.5-.2-1-1.2-.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.8,66.2c.6-.3,1.5-.1,1.7,.6,.2,.5,.2,1.2-.3,1.5-.7,.5-1.8,0-2-.9-.1-.4,.2-.9,.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.5,66.7c1-.4,2,.8,1.6,1.7-.2,.5-.8,.7-1.3,.7-.4-.1-.8-.4-1-.8-.3-.5,.1-1.3,.7-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.8,67.6c.7-.4,1.6,.6,1.3,1.3-.3,.5-1.2,.5-1.5,0-.4-.3-.2-1,.2-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.3,67.9c.8-.2,1.7,.7,1.3,1.4-.5,.8-2,.1-1.9-.8,.1-.3,.3-.6,.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.2,68.5c.6-.3,1.3,.2,1.6,.8,.2,.5-.1,1-.6,1.1-.7,.2-1.5-.3-1.5-1-.1-.4,.1-.8,.5-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.2,68.6c.6-.2,1.4-.1,1.6,.5,.3,.8-.8,1.5-1.5,1-.5-.2-.8-1.2-.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,69.1c.8-.3,1.8,.6,1.4,1.4-.4,.6-1.4,.3-1.8-.3-.2-.3,0-.9,.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.6,69.2c.7-.4,1.9,.5,1.6,1.3-.1,.4-.6,.7-1,.6-.5,0-.9-.4-1.1-.9,0-.3,.2-.7,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.1,69.6c.7-.2,1.6,.3,1.6,1.1-.1,.5-.4,1.1-1,1.2s-1.1-.4-1.3-.9c-.2-.6,.2-1.3,.7-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,70c.7-.2,1.5,.3,1.6,1.1-.1,.4-.3,.8-.7,.9-.6,.2-1.4-.2-1.5-.8-.2-.5,.2-1.1,.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,70.2c.8-.3,1.8,.6,1.4,1.4-.5,.7-1.5,.3-1.8-.4-.2-.3,0-.8,.4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.8,70.8c.7-.3,1.6,.3,1.7,1-.1,.8-1.3,1.1-1.8,.5-.6-.4-.5-1.2,.1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.9,71.2c.8-.3,1.7,.6,1.5,1.4-.2,.6-1,.8-1.5,.4-.7-.4-.7-1.5,0-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.3,71.6c.4-.1,.8,.1,1.1,.3,.7,.4,.5,1.7-.3,1.8-.6,.2-1.1-.2-1.4-.6-.4-.5,.1-1.3,.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.7,71.7c.6-.3,1.3,.5,1,1.1-.3,.5-1.1,.5-1.4,0-.3-.4-.1-1,.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.9,72.1c.5-.2,1.1,.1,1.5,.5,.5,.7-.3,1.8-1.1,1.5-.5-.2-.9-.8-.9-1.4,0-.3,.3-.5,.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.5,72.4c.6-.4,1.3,.3,1.5,.8,0,.6-.7,1-1.2,.7-.7-.2-.9-1.2-.3-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.5,73.9c.7-.3,1.6,.3,1.5,1.1,0,.7-1,1.2-1.5,.7-.5-.4-.8-1.5,0-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.1,74c.8-.4,1.7,.7,1.3,1.4-.3,.5-1.1,.5-1.5,0-.5-.3-.4-1.2,.2-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.1,74.1c.5-.2,1.2,.1,1.4,.6,.2,.7-.8,1.3-1.4,.8-.5-.3-.6-1.1,0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.9,74.2c.6-.3,1.4,.1,1.7,.7,.3,.5-.1,1.2-.6,1.4-.7,.3-1.6-.2-1.7-1-.1-.5,.2-.9,.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.7,74.1c.8-.2,1.7,.7,1.3,1.4-.5,.7-1.6,.2-1.8-.4-.1-.4,.1-.9,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.6,74.5c.6-.2,1.4,.2,1.5,.9,.1,.7-.7,1-1.3,.9-.6-.2-1-.9-.8-1.4,.2-.2,.4-.3,.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.1,74.9c.9-.2,1.9,.8,1.5,1.7-.4,.8-1.6,.8-2.1,.1-.5-.6-.3-1.8,.6-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.2,75.5c.5-.2,1.2,.2,1.3,.7,0,.6-.8,1.1-1.3,.8-.6-.3-.6-1.2,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.3,76.2c.8-.4,1.7,.5,1.4,1.3-.2,.5-.9,.6-1.3,.4-.7-.2-.8-1.4-.1-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,77.5c.6-.3,1.6,.1,1.7,.8,.2,.8-.7,1.2-1.4,1.1-.6-.3-1-1.5-.3-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.7,77.8c.9-.3,2.1,.5,1.8,1.5-.3,.7-1.3,1-1.9,.5-.8-.5-.7-1.7,.1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.3,78.7c.7-.4,1.8,.4,1.5,1.2-.2,.6-1.1,.9-1.6,.4-.6-.4-.6-1.4,.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,79.8c.9-.4,2,.6,1.8,1.6-.1,.5-.7,.8-1.2,.8s-.9-.4-1.2-.8c-.3-.6,0-1.3,.6-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.8,81.5c.7-.2,1.4,.3,1.6,1,.2,.5-.3,1-.8,1-.7,.2-1.4-.4-1.4-1,0-.5,.2-.9,.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.7,84.7c.4-.3,.9-.1,1.3,.1,.7,.4,.6,1.6-.2,1.8-.6,.3-1.2-.2-1.5-.6s0-1,.4-1.3Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLeather);
export default __webpack_public_path__ + "static/media/custom-leather.5d36d5818e3f4408e241c0dc3faf0781.svg";
export { ForwardRef as ReactComponent };